import {httpClient} from "../funcs";
import {notifyAboutError} from "./notifyUser";

export const VERIFICATION_CODE_REQUEST_TIMEOUT_MS = 30000

export type VerificationCodeResponse = {
    usedChannel: string | null
    dialPhone?: string
    reverseCallCode?: string
    disabledCodeChannels?: string[]
    reverseFlashCallEnabled?: boolean
}

function parseJsonData(data: any): Record<string, any> {
    if (typeof data === 'string') {
        try {
            return JSON.parse(data)
        } catch {
            return {}
        }
    }
    return data || {}
}

function parseVerificationCodeResponse(response: any, fallbackChannel: string): VerificationCodeResponse {
    const data = parseJsonData(response?.data)
    return {
        usedChannel: data.used_channel ?? fallbackChannel,
        dialPhone: data.dial_phone,
        reverseCallCode: data.reverse_call_code,
        disabledCodeChannels: data.disabled_code_channels,
        reverseFlashCallEnabled: data.reverse_flash_call_enabled,
    }
}

// Старая функция для явного указания канала (для обратной совместимости)
export async function sendVerificationCode(
    props: any,
    phone_number: string,
    code_channel: string,
    purpose: string,
    purpose_meta: Record<string, any> = {}
): Promise<VerificationCodeResponse> {
    try {
        const response = await httpClient.post('/verification-code', {
            phone_number: phone_number,
            channel: code_channel,
            purpose: purpose,
            purpose_meta: purpose_meta
        }, {
            timeout: VERIFICATION_CODE_REQUEST_TIMEOUT_MS,
        })
        return parseVerificationCodeResponse(response, code_channel)
    } catch (error) {
        notifyAboutError(props, error)
        throw error
    }
}

// Новая функция с автоматическим выбором канала на основе preffered_code_channel из config
export async function sendVerificationCodePreferred(
    props: any,
    phone_number: string,
    purpose: string,
    purpose_meta: Record<string, any> = {}
): Promise<VerificationCodeResponse> {
    try {
        const response = await httpClient.post('/verification-code-preferred', {
            phone_number: phone_number,
            purpose: purpose,
            purpose_meta: purpose_meta
        }, {
            timeout: VERIFICATION_CODE_REQUEST_TIMEOUT_MS,
        })
        return parseVerificationCodeResponse(response, 'sms')
    } catch (error) {
        notifyAboutError(props, error)
        throw error
    }
}

export async function fetchVerificationDisabledCodeChannels(contractId?: string): Promise<{
    disabledCodeChannels: string[]
    reverseFlashCallEnabled: boolean
}> {
    const response = await httpClient.get('/verification-code/disabled-channels', {
        params: contractId ? { contract_id: contractId } : undefined,
    })
    const data = parseJsonData(response?.data)
    return {
        disabledCodeChannels: data.disabled_code_channels || [],
        reverseFlashCallEnabled: data.reverse_flash_call_enabled === true,
    }
}

export async function fetchReverseCallStatus(phone_number: string): Promise<{
    confirmed: boolean
    dial_phone?: string
    code?: string
}> {
    const response = await httpClient.get('/verification-code/reverse-call-status', {
        params: { phone_number },
    })
    const data = parseJsonData(response?.data)
    return {
        confirmed: data.confirmed === true,
        dial_phone: data.dial_phone,
        code: data.code,
    }
}
